import type { SortMode } from '~/models/Filter.models';

export const sortPhonesProductCards = (
  products: ProductCard[],
  sortMode: SortMode,
) => {
  const productsCopy = products.slice(); // Shallow copy works with just sorting

  switch (sortMode) {
    case 'Lägst pris':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return (
          (a.bundlePrice?.TotalCost ?? 1) - (b.bundlePrice?.TotalCost ?? 1)
        );
      });
    case 'Högst pris':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return (
          (b.bundlePrice?.TotalCost ?? 1) - (a.bundlePrice?.TotalCost ?? 1)
        );
      });
    case 'Namn A - Ö':
      return productsCopy.sort((a: ProductCard, b: ProductCard) =>
        ('' + a.product.ProductName).localeCompare(b.product.ProductName),
      );
    case 'Namn Ö - A':
      return productsCopy.sort((a: ProductCard, b: ProductCard) =>
        ('' + b.product.ProductName).localeCompare(a.product.ProductName),
      );
    case 'Nyast':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return (
          new Date(b.product.ReleaseDateLocal).getTime() -
          new Date(a.product.ReleaseDateLocal).getTime()
        );
      });
    case 'Populärast':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return a.product.PopularityIndex - b.product.PopularityIndex;
      });
    default:
      return productsCopy;
  }
};

export const sortAccesoryProductCards = (
  products: ProductCard[],
  sortMode: SortMode,
) => {
  const productsCopy = products.slice();

  switch (sortMode) {
    case 'Lägst pris':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return (
          (a.variant.Prices.Price?.Price || 0) -
          (b.variant.Prices.Price?.Price || 0)
        );
      });
    case 'Högst pris':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return (
          (b.variant.Prices.Price?.Price || 0) -
          (a.variant.Prices.Price?.Price || 0)
        );
      });
    case 'Namn A - Ö':
      return productsCopy.sort((a: ProductCard, b: ProductCard) =>
        ('' + a.product.ProductName).localeCompare(b.product.ProductName),
      );
    case 'Namn Ö - A':
      return productsCopy.sort((a: ProductCard, b: ProductCard) =>
        ('' + b.product.ProductName).localeCompare(a.product.ProductName),
      );
    case 'Nyast':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return (
          new Date(a.product.ReleaseDateLocal).getTime() -
          new Date(b.product.ReleaseDateLocal).getTime()
        );
      });
    case 'Populärast':
      return productsCopy.sort((a: ProductCard, b: ProductCard) => {
        return a.product.PopularityIndex - b.product.PopularityIndex;
      });
    default:
      return productsCopy;
  }
};
